export default "__VITE_PUBLIC_ASSET__01cfe7dc__"